import { dataReportStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportStarSolid = /*#__PURE__*/createIcon(dataReportStarSolid)
export default IconReportStarSolid
